import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { USER_ROLES } from './types/user';
import { QueryClientProvider } from '@tanstack/react-query';
import { queryClient } from './app/queryClient';
import Navigation from './components/Navigation';
import { AuthProvider } from './auth/AuthContext';
import ProtectedRoute from './auth/ProtectedRoute';
import DashboardLayout from './components/dashboard/DashboardLayout';
import Home from './pages/Home';
import Products from './pages/Products';
import Services from './pages/Services';
import Portfolio from './pages/Portfolio';
import About from './pages/About';
import Contact from './pages/Contact';
import Login from './pages/Login';
import AcceptInvitation from './pages/AcceptInvitation';
import DashboardOverview from './pages/dashboard/DashboardOverview';
import ProjectList from './pages/dashboard/ProjectList';
import ProjectDetail from './pages/dashboard/ProjectDetail';
import IntakeRequests from './pages/dashboard/IntakeRequests';
import UserAdmin from './pages/dashboard/UserAdmin';
import AccountSettings from './pages/dashboard/AccountSettings';
import './App.css';

function AppFrame() {
  const location = useLocation();
  const isDashboardRoute = location.pathname.startsWith('/dashboard');

  return (
    <div className="App">
      {!isDashboardRoute && <Navigation />}
      <main className={isDashboardRoute ? 'dashboard-content' : 'main-content'}>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/products" element={<Products />} />
          <Route path="/services" element={<Services />} />
          <Route path="/portfolio" element={<Portfolio />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/login" element={<Login />} />
          <Route path="/accept-invitation" element={<AcceptInvitation />} />
          <Route
            path="/dashboard"
            element={
              <ProtectedRoute>
                <DashboardLayout />
              </ProtectedRoute>
            }
          >
            <Route index element={<DashboardOverview />} />
            <Route path="projects" element={<ProjectList />} />
            <Route path="projects/:projectId" element={<ProjectDetail />} />
            <Route
              path="requests"
              element={
                <ProtectedRoute allowedRoles={[USER_ROLES.ADMIN]}>
                  <IntakeRequests />
                </ProtectedRoute>
              }
            />
            <Route
              path="users"
              element={
                <ProtectedRoute allowedRoles={[USER_ROLES.ADMIN]}>
                  <UserAdmin />
                </ProtectedRoute>
              }
            />
            <Route path="settings" element={<AccountSettings />} />
          </Route>
        </Routes>
      </main>
    </div>
  );
}

function App() {
  return (
      <QueryClientProvider client={queryClient}>
        <AuthProvider>
          <Router>
            <AppFrame />
          </Router>
        </AuthProvider>
      </QueryClientProvider>
  );
}

export default App;
